var _rect, _rect2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExitWalletInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 59,
    viewBox: "0 0 59 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 59,
    height: 59,
    rx: 29.5,
    fill: "#951F6F"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1852_2471",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 10,
    width: 39,
    height: 39
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10,
    width: 39,
    height: 39,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1852_2471)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.5 37.625C29.9604 37.625 30.3464 37.4693 30.6578 37.1578C30.9693 36.8464 31.125 36.4604 31.125 36V29.5C31.125 29.0396 30.9693 28.6536 30.6578 28.3422C30.3464 28.0307 29.9604 27.875 29.5 27.875C29.0396 27.875 28.6536 28.0307 28.3422 28.3422C28.0307 28.6536 27.875 29.0396 27.875 29.5V36C27.875 36.4604 28.0307 36.8464 28.3422 37.1578C28.6536 37.4693 29.0396 37.625 29.5 37.625ZM29.5 24.625C29.9604 24.625 30.3464 24.4693 30.6578 24.1578C30.9693 23.8464 31.125 23.4604 31.125 23C31.125 22.5396 30.9693 22.1536 30.6578 21.8422C30.3464 21.5307 29.9604 21.375 29.5 21.375C29.0396 21.375 28.6536 21.5307 28.3422 21.8422C28.0307 22.1536 27.875 22.5396 27.875 23C27.875 23.4604 28.0307 23.8464 28.3422 24.1578C28.6536 24.4693 29.0396 24.625 29.5 24.625ZM29.5 45.75C27.2521 45.75 25.1396 45.3234 23.1625 44.4703C21.1854 43.6172 19.4656 42.4594 18.0031 40.9969C16.5406 39.5344 15.3828 37.8146 14.5297 35.8375C13.6766 33.8604 13.25 31.7479 13.25 29.5C13.25 27.2521 13.6766 25.1396 14.5297 23.1625C15.3828 21.1854 16.5406 19.4656 18.0031 18.0031C19.4656 16.5406 21.1854 15.3828 23.1625 14.5297C25.1396 13.6766 27.2521 13.25 29.5 13.25C31.7479 13.25 33.8604 13.6766 35.8375 14.5297C37.8146 15.3828 39.5344 16.5406 40.9969 18.0031C42.4594 19.4656 43.6172 21.1854 44.4703 23.1625C45.3234 25.1396 45.75 27.2521 45.75 29.5C45.75 31.7479 45.3234 33.8604 44.4703 35.8375C43.6172 37.8146 42.4594 39.5344 40.9969 40.9969C39.5344 42.4594 37.8146 43.6172 35.8375 44.4703C33.8604 45.3234 31.7479 45.75 29.5 45.75ZM29.5 42.5C33.1292 42.5 36.2031 41.2406 38.7219 38.7219C41.2406 36.2031 42.5 33.1292 42.5 29.5C42.5 25.8708 41.2406 22.7969 38.7219 20.2781C36.2031 17.7594 33.1292 16.5 29.5 16.5C25.8708 16.5 22.7969 17.7594 20.2781 20.2781C17.7594 22.7969 16.5 25.8708 16.5 29.5C16.5 33.1292 17.7594 36.2031 20.2781 38.7219C22.7969 41.2406 25.8708 42.5 29.5 42.5Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExitWalletInfoIcon);
export default __webpack_public_path__ + "static/media/exit-wallet-info-icon.16f44990182abf11b855983b1449f31a.svg";
export { ForwardRef as ReactComponent };